import { demoFile, feature } from 'system/demo';
import { TopicPollFeature } from '../topic-poll';
import { SimpleCommentsStructure } from 'structure/simple-comments';

demoFile('open-modules/cbcrc/feature/topic/topic-poll');

feature('Topic Poll', {
    structureKey: 'simplecomments',
    config: SimpleCommentsStructure.receivesConfigDefaults,
    features: { topicpoll: true }
});
